enum MedicalCalculatorParamType {
    CHECKBOX = 'CHECKBOX',
    TOGGLE = 'TOGGLE',
    MULTI_SELECT = 'MULTI_SELECT',
    DATE = 'DATE',
    INPUT = 'INPUT'
}

export default MedicalCalculatorParamType;
